import React from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { CustomSortIcon } from "../../../../components/DatatableHelpers";
import { WritingUsageByWriter, WritingUsage } from "./UsageFilteredByCourseViewModel";

export function WritingUsageTable(props: {
	className?: string;
	courseId: number;
	writingUsageByWriter: WritingUsageByWriter[];
	writingUsageTotalForCourse: WritingUsage;
}) {
	const studentBodyTemplate = (rowData: WritingUsageByWriter) => {
		return (
			<Link
				className="link"
				to={`/reports/student/usage?writerId=${rowData.writerId}&courseId=${props.courseId}`}>
				{rowData.writerName}
			</Link>
		);
	};

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer="Class" footerClassName="font-medium !text-right" />
				<Column
					footer={props.writingUsageTotalForCourse.essayCount}
					footerClassName="font-medium"
				/>
				<Column
					footer={props.writingUsageTotalForCourse.draftCount}
					footerClassName="font-medium"
				/>
				<Column
					footer={props.writingUsageTotalForCourse.draftPerEssayAverageCount}
					footerClassName="font-medium"
				/>
			</Row>
		</ColumnGroup>
	);

	const hasData = props.writingUsageByWriter && props.writingUsageByWriter.length > 0;

	return (
		<DataTable
			value={props.writingUsageByWriter}
			dataKey="writerId"
			loading={props.writingUsageByWriter == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default ${props.className}`}
			footerColumnGroup={hasData && footerGroup}>
			<Column
				header="Student"
				body={studentBodyTemplate}
				sortable
				sortField="writerName"></Column>
			<Column header="Number of Essays" field="essayCount" sortable></Column>
			<Column header="Number of Drafts" field="draftCount" sortable></Column>
			<Column
				header="Avg Drafts per Essay"
				field="draftPerEssayAverageCount"
				sortable></Column>
		</DataTable>
	);
}
